/* Copyright (c) 2021-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import { Label } from "@nordcloud/gnui";
import { Fieldset } from "~/components/Forms";
import { LabelWithTooltip } from "~/components/Forms/LabelWithTooltip/LabelWithTooltip";

export type SidebarFormFieldProps = {
  label: string;
  required?: boolean;
  tooltip?: string;
  inputId?: string;
};

type AllProps = SidebarFormFieldProps & {
  children: React.ReactNode;
};

function SidebarFormField(props: AllProps) {
  const required = props.required || false;

  return (
    <Fieldset>
      {props.tooltip ? (
        <LabelWithTooltip
          labelName={props.label}
          required={required}
          htmlFor={props.inputId}
          tooltipText={props.tooltip}
          position="left"
        />
      ) : (
        <Label name={props.label} required={required} htmlFor={props.inputId} />
      )}

      {props.children}
    </Fieldset>
  );
}

export { SidebarFormField };
